import {
  InputHTMLAttributes,
  useId,
} from 'react';

import { cn } from 'utils/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Radio = ({ checked, className, ...props }: Props) => {
  const id = useId();

  return (
    <label htmlFor={id} className={cn('block relative cursor-pointer select-none w-5 h-5', className)}>
      <input
        id={id}
        type="radio"
        className="absolute opacity-0 h-0 w-0 cursor-pointer"
        checked={checked}
        {...props}
      />
      <div
        className={cn(
          'flex items-center justify-center w-full h-full border border-grey300 bg-white transition-all duration-200 rounded-full p-0.5',
          {
            'border-[#007AC1]': checked,
          },
        )}
      >
        {checked && <div className="w-full h-full bg-[#007AC1] rounded-full"/>}
      </div>
    </label>
  );
};

export default Radio;
